export const ACTIVITY_TYPE = {
    ASSIGNED: '1',
    PLANNED: '2'
}

export const PAYMENT_OUTCOME_UNIT = [
    { value: 1, name: 'Number' },
    { value: 2, name: 'Area' },
    { value: 3, name: 'Days' }
]

export const PAYMENT_OUTCOME_UNIT_OBJECT = {
    1: 'Number',
    2: 'Area',
    3: 'Days'
}

export const ACTIVITY_STATUS = {
    IN_PROGRESS: '1',
    APPROVAL_PENDING: '2',
    DRAFT: '3',
    REPORT_DUE: '4',
    COMPLETED: '5',
    DECLINED: '6',
    RESUBMIT_REPORT: '7',
    REPORT_SUBMITTED: '8',
    REJECTED: '9',
    '1': 'In Progress',
    '2': 'Approval Pending',
    '3': 'Draft',
    '4': 'Report Due',
    '5': 'Completed',
    '6': 'Declined',
    '7': 'Resubmit Report',
    '8': 'Report Submitted',
    '9': 'Rejected'
}

export const ACTIVITY_STATUS_COLUMNS = ['activity_name', 'assigned_date', 'sub_role', 'payment_model_name', 'end_date', 'status']
export const REPORT_STATUS_COLUMNS = ['activity_name', 'assigned_date', 'sub_role', 'date_of_submission', 'payment_model_name', 'status']


export const MONTHS = [{ id: 1, name: 'January' }, { id: 2, name: 'February' }, { id: 3, name: 'March' }, { id: 4, name: 'April' }, { id: 5, name: 'May' }, { id: 6, name: 'June' }, { id: 7, name: 'July' }, { id: 8, name: 'August' }, { id: 9, name: 'September' }, { id: 10, name: 'October' }, { id: 11, name: 'November' }, { id: 12, name: 'November' }]


export const PAYMENT_MODEL_ARRAY = [
    {
        name: 'Monthly(Fixed)',
        id: 1
    },
    {
        name: 'Day Wise',
        id: 2
    },
    {
        name: 'Activity Wise',
        id: 3
    }
]

export const PAYMENT_MODEL_OBJECT = {
    1: 'Monthly(Fixed)',
    2: 'Day Wise',
    3: 'Activity Wise'
}

export const ACTIVITY_STATUS_COLOR = {
    '1': {
        text: '#006473',
        borderColor: "#006473",
        background: '#EEFDFF'
    },
    '2': {
        text: '#FF6D00',
        borderColor: "#FF6D00",
        background: '#FFF4EB'
    },
    '3': {
        text: '#2962FF',
        borderColor: "#2962FF",
        background: '#EEF3FF'
    },
    '4': {
        text: '#FF6D00',
        borderColor: "#FF6D00",
        background: '#FFF4EB'
    },
    '5': {
        text: '#00944A',
        borderColor: "#00944A",
        background: '#EBF7F1'
    },
    '6': {
        text: '#D50000',
        borderColor: "#D50000",
        background: '#FFF4F4'
    },
    '7': {
        text: '#D50000',
        borderColor: "#D50000",
        background: '#FFF4F4'
    },
    '8': {
        text: '#2962FF',
        borderColor: "#2962FF",
        background: '#EEF3FF'
    },
    '9': {
        text: '#D50000',
        borderColor: "#D50000",
        background: '#FFF4F4'
    }
}

export const ACTIVITY_STATUS_ARRAY = [
    {
        name: 'IN_PROGRESS',
        id: 1
    },
    {
        name: 'APPROVAL_PENDING',
        id: 2
    },
    {
        name: 'DRAFT',
        id: 3
    },
    {
        name: 'REPORT_DUE',
        id: 4
    },
    {
        name: 'COMPLETED',
        id: 5
    },
    {
        name: 'DECLINED',
        id: 6
    },
    {
        name: 'RESUBMIT_REPORT',
        id: 7
    },
    {
        name: 'REPORT_SUBMITTED',
        id: 8
    },
    {
        name: 'REJECTED',
        id: 9
    },
]



export const ACTIVITY_STATUS_FOR_ACTIVITY_TAB = [
    {
        name: 'In Progress',
        id: 1
    },
    {
        name: 'Approval Pending',
        id: 2
    },
    {
        name: 'Draft',
        id: 3
    },
    {
        name: 'Report Due',
        id: 4
    },
    // {
    //     name: 'COMPLETED',
    //     id: 5
    // },
    {
        name: 'Declined',
        id: 6
    },
    // {
    //     name: 'RESUBMIT_REPORT',
    //     id: 7
    // },
    // {
    //     name: 'REPORT_SUBMITTED',
    //     id: 8
    // },
    // {
    //     name: 'REJECTED',
    //     id: 9
    // },
]

export const ACTIVITY_STATUS_TAB_DEFAULT_FILTER = ACTIVITY_STATUS.APPROVAL_PENDING + ',' + ACTIVITY_STATUS.REPORT_DUE + ',' + ACTIVITY_STATUS.IN_PROGRESS + ',' + ACTIVITY_STATUS.DECLINED + ',' + ACTIVITY_STATUS.DRAFT
export const REPORT_STATUS_TAB_DEFAULT_FILTER = ACTIVITY_STATUS.REPORT_SUBMITTED + ',' + ACTIVITY_STATUS.REJECTED + ',' + ACTIVITY_STATUS.COMPLETED

export const REPORT_STATUS_FOR_ACTIVITY_TAB = [
    // {
    //     name: 'IN_PROGRESS',
    //     id: 1
    // },
    // {
    //     name: 'APPROVAL_PENDING',
    //     id: 2
    // },
    // {
    //     name: 'DRAFT',
    //     id: 3
    // },
    // {
    //     name: 'REPORT_DUE',
    //     id: 4
    // },
    // {
    //     name: 'COMPLETED',
    //     id: 5
    // },
    // {
    //     name: 'DECLINED',
    //     id: 6
    // },
    {
        name: 'Completed',
        id: 5
    },
    // {
    //     name: 'RESUBMIT_REPORT',
    //     id: 7
    // },
    {
        name: 'Report Submitted',
        id: 8
    },
    {
        name: 'Rejected',
        id: 9
    },
]


export const ROLES_TYPES = {
    'Block Admin': "Block Admin"
}

export const ROLES_ABBREVATIONS = {
    'b': {
        role: 'admin'
    }
}

export const ROLES_VERTICLE = {

}

export const ROLES = {
    'national': {
        profile: {
            edit: false
        },
        activity: {
            edit: false
        },
        payment: {
            edit: false
        },
        cadreRoleConfig: {
            edit: false
        },
        categoryMatser: {
            edit: false
        },
        subCategoryMatser: {
            edit: false
        },
        activityMatser: {
            edit: false
        }
    },
    'state': {
        profile: {
            edit: false
        },
        activity: {
            edit: false
        },
        payment: {
            edit: false
        },
        cadreRoleConfig: {
            edit: true
        },
        categoryMatser: {
            edit: true
        },
        subCategoryMatser: {
            edit: true
        },
        activityMatser: {
            edit: true
        }
    },
    'district': {
        profile: {
            edit: false
        },
        activity: {
            edit: false
        },
        payment: {
            edit: false
        },
        cadreRoleConfig: {
            edit: false
        },
        categoryMatser: {
            edit: false
        },
        subCategoryMatser: {
            edit: false
        },
        activityMatser: {
            edit: false
        }
    },
    'block': {
        profile: {
            edit: true
        },
        activity: {
            edit: true
        },
        payment: {
            edit: true
        },
        cadreRoleConfig: {
            edit: false
        },
        categoryMatser: {
            edit: false
        },
        subCategoryMatser: {
            edit: false
        },
        activityMatser: {
            edit: false
        }
    }
}

export const ROLE_CONFIG = {
    "state-manager-ib": {
        userType: 'state',
        verticle: 'Institutional Building',
        name: 'State Manager IB',
        active: true,
        ogName: 'state-manager-ib'
    },
    "state-manager-fi": {
        userType: 'state',
        verticle: 'Financial Inclusion',
        name: 'State Manager FI',
        active: true,
        ogName: 'state-manager-fi'
    },
    "state-manager-farm": {
        userType: 'state',
        verticle: 'Livelihood Farm',
        name: 'State Manager Farm',
        active: true,
        ogName: 'state-manager-farm'
    },
    "state-manager-nonfarm": {
        userType: 'state',
        verticle: 'Livelihood Non-Farm',
        name: 'State Manager Non-Farm',
        active: true,
        ogName: 'state-manager-nonfarm'
    },
    "state-manager-sisd": {
        userType: 'state',
        verticle: 'SISD',
        name: 'State Manager SISD',
        active: true,
        ogName: 'state-manager-sisd'
    },
    "state-administrator": {
        userType: 'state',
        verticle: '',
        name: 'State Admin',
        active: true,
        ogName: 'state-administrator'
    },
    
    // "state-release-reviewer": {
    //     userType: 'state',
    //     verticle: '',
    //     name: 'State Manager IB',
    //     active: false
    // },
    // "state-release-manager": {
    //     userType: 'state',
    //     verticle: '',
    //     name: 'State Manager IB',
    //     active: false
    // },
    // "state-finance-manager": {
    //     userType: 'state',
    //     verticle: '',
    //     name: 'State Manager IB',
    //     active: false
    // },
    // "state-approving-authority": {
    //     userType: 'state',
    //     verticle: 'farm',
    //     name: 'State Manager IB',
    //     active: false
    // },
    "clf-bookkeeper": {
    userType: 'block',
    verticle: 'Institutional Building',
    name: 'CLF Bookkeeper',
    active: true,
    ogName: 'CLF Bookkeeper'
},

    "block-manager-ib": {
        userType: 'block',
        verticle: 'Institutional Building',
        name: 'Block Manager IB',
        active: true,
        ogName: 'block-manager-ib'
    },
    "block-manager-fi": {
        userType: 'block',
        verticle: 'Financial Inclusion',
        name: 'Block Manager FI',
        active: true,
        ogName: 'block-manager-fi'
    },
    "block-manager-farm": {
        userType: 'block',
        verticle: 'Livelihood Farm',
        name: 'Block Manager Farm',
        active: true,
        ogName: 'block-manager-farm'
    },
    "block-manager-nonfarm": {
        userType: 'block',
        verticle: 'Livelihood Non-Farm',
        name: 'Block Manager Non-Farm',
        active: true,
        ogName: 'block-manager-nonfarm'
    },
    "block-manager-sisd": {
        userType: 'block',
        verticle: 'SISD',
        name: 'Block Manager SISD',
        active: true,
        ogName: 'block-manager-sisd'
    },
    // "block-approving-authority": {
    //     userType: 'block',
    //     verticle: '',
    //     name: 'Block Approving Authority',
    //     active: false
    // },
    // "cbo-bookkeeper": {
    //     userType: 'block',
    //     verticle: '',
    //     name: 'State Manager IB',
    //     active: false
    // },
    "block-administrator": {
        userType: 'block',
        verticle: '',
        name: 'Block Admin',
        active: true,
        ogName: 'block-administrator'
    },

    "national-administrator": {
        userType: 'national',
        verticle: '',
        name: 'National Admin',
        active: true,
        ogName: 'national-administrator'
    },
    "national-manager-ib": {
        userType: 'national',
        verticle: 'Institutional Building',
        name: 'National Manager IB',
        active: true,
        ogName: 'national-manager-ib'
    },
    "national-manager-fi": {
        userType: 'national',
        verticle: 'Financial Inclusion',
        name: 'National Manager FI',
        active: true,
        ogName: 'national-manager-fi'
    },
    "national-manager-nonfarm": {
        userType: 'national',
        verticle: 'Livelihood Non-Farm',
        name: 'National Manager Non-Farm',
        active: true,
        ogName: 'national-manager-nonfarm'
    },
    "national-manager-farm": {
        userType: 'national',
        verticle: 'Livelihood Farm',
        name: 'National Manager Farm',
        active: true,
        ogName: 'national-manager-farm'
    },
    "national-manager-sisd": {
        userType: 'national',
        verticle: 'SISD',
        name: 'National Manager SISD',
        active: true,
        ogName: 'national-manager-sisd'
    },

    "district-manager-ib": {
        userType: 'district',
        verticle: 'Institutional Building',
        name: 'District Manager IB',
        active: true,
        ogName: 'district-manager-ib'
    },
    "district-manager-fi": {
        userType: 'district',
        verticle: 'Financial Inclusion',
        name: 'District Manager FI',
        active: true,
        ogName: 'district-manager-fi'
    },
    "district-manager-farm": {
        userType: 'district',
        verticle: 'Livelihood Farm',
        name: 'District Manager Farm',
        active: true,
        ogName: 'district-manager-farm'
    },
    "district-manager-nonfarm": {
        userType: 'district',
        verticle: 'Livelihood Non-Farm',
        name: 'District Manager Non-Farm',
        active: true,
        ogName: 'district-manager-nonfarm'
    },
    "district-manager-sisd": {
        userType: 'district',
        verticle: 'SISD',
        name: 'District Manager SISD',
        active: true,
        ogName: 'district-manager-sisd'
    },
    "district-administrator": {
        userType: 'district',
        verticle: '',
        name: 'District Admin',
        active: true,
        ogName: 'district-administrator'
    },
    // "district-release-reviewer": {
    //     userType: 'district',
    //     verticle: '',
    //     name: 'District Manager IB',
    //     active: false
    // },
    // "district-release-manager": {
    //     userType: 'district',
    //     verticle: '',
    //     name: 'District Manager IB',
    //     active: false
    // },
    // "district-finance-manager": {
    //     userType: 'district',
    //     verticle: '',
    //     name: 'District Manager IB',
    //     active: false
    // },
    // "district-approving-authority": {
    //     userType: 'district',
    //     verticle: 'farm',
    //     name: 'District Manager IB',
    //     active: false
    // },

}


